import { useRouter } from "next/router";
import { useEffect } from "react";
import { ErrorBoundaryProps } from "./ErrorBoundaryProps";
import { routesDefinitions } from "lib/actions/routeDefinitions";

export default function Workspace402SubscriptionRequiredError(
  p: ErrorBoundaryProps & {
    workspaceId: number;
  },
): React.JSX.Element {
  const router = useRouter();

  useEffect(() => {
    if (routesDefinitions.workspacePaywall.regex.test(router.pathname)) {
      p.onReset?.();

      return;
    }

    router.replace(`/workspaces/${p.workspaceId}/paywall`).then(() => {
      p.onReset?.();
    });
  }, []);

  return null;
}
